module.exports = __webpack_public_path__ + "pr.svg?688c6f9025626aa01ad7b8a3b0322401";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/pr.svg
// module id = 1108
// module chunks = 27